import React from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Typography, TypographyProps, Header } from '../typography';

type SectionSubtitleMargin = 'l' | 'm' | 's' | 'none';

export type SectionSubTitleProps = {
  adaptiveMargin?: boolean;
  margin: SectionSubtitleMargin;
  variant?: Header;
  size?: 'extra';
} & Omit<TypographyProps, 'variant' | 'size'>;

const styles = css`
  width: 100%;
`;

const marginStylesMap: Record<SectionSubtitleMargin, string> = {
  l: css`
    margin-bottom: 32px;
  `,
  m: css`
    margin-bottom: 24px;
  `,
  s: css`
    margin-bottom: 16px;
  `,
  none: css`
    margin-bottom: 0;
  `,
};

const adaptiveMarginStylesMap: Omit<Record<SectionSubtitleMargin, string>, 'none'> = {
  l: css`
    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  `,
  m: css`
    @media (--only-mobile) {
      margin-bottom: 16px;
    }
  `,
  s: css`
    @media (--only-mobile) {
      margin-bottom: 8px;
    }
  `,
};

export const SectionSubTitle: React.FC<SectionSubTitleProps> = ({
  adaptiveMargin,
  as = 'h2',
  className,
  children,
  margin,
  variant = 'h2',
  ...rest
}: SectionSubTitleProps) => (
  <Typography
    as={as}
    className={cn(
      styles,
      className,
      marginStylesMap[margin],
      margin === 'none' ? {} : { [adaptiveMarginStylesMap[margin]]: adaptiveMargin }
    )}
    {...(rest as SectionSubTitleProps)}
    variant={variant}
  >
    {children}
  </Typography>
);
